import classNames from 'classnames';
import { CarouselItemViewModel, ComponentType } from '@/types/cml-api';
import { AppNextLink } from '@/features/app-next-link';
import LazyImage from '@/features/image/lazy-image';
import { useMobileDetect } from '@/features/mobile-detect-context/mobile-detect-provider';
import { Webengage } from '@/features/webengage';
import { useDataLayerPush } from '../../../_utils/use-datalayer-push';
import { DataLayerProps, IsLoadingLazyProps } from '../../type';
import { elementTrackingId } from '../contants';
interface Props extends IsLoadingLazyProps, CarouselItemViewModel, DataLayerProps {}
function BannerTileItem({
  link,
  desktopImageUrl,
  mobileImageUrl,
  title,
  subTitle,
  isLazy,
  index,
  id,
  sortKey,
  componentId,
  isBannerTileWithText
}: Props) {
  const {
    isMobile
  } = useMobileDetect();
  const pushToDataLayer = useDataLayerPush();
  const handleClick = () => {
    const destinationUrl = link ?? '';
    const elementType = ComponentType.BannerTile;
    const itemId = id || '';
    const imageUrl = isMobile ? mobileImageUrl : desktopImageUrl;
    pushToDataLayer({
      event: elementTrackingId,
      elementType: elementType,
      elementIndex: index || 0,
      itemID: itemId,
      elementName: sortKey,
      destinationUrl: destinationUrl,
      componentId,
      ImageUrl: imageUrl
    });
    Webengage.trackCtaAction({
      component_id: componentId ?? '',
      banner_type: elementType,
      banner_name: sortKey ?? '',
      item_id: itemId,
      banner_index: index?.toString() || '0',
      url_destination: destinationUrl,
      image_url: imageUrl ?? ''
    });
  };
  if (!mobileImageUrl || !title) return null;
  return <AppNextLink aria-label={title} onClick={handleClick} href={link || ''} prefetch={false} className={classNames('overflow-hidden bg-white', isBannerTileWithText ? 'flex flex-col items-center px-3 py-2' : 'rounded')} data-sentry-element="AppNextLink" data-sentry-component="BannerTileItem" data-sentry-source-file="banner-tile-item.tsx">
            <picture data-sentry-element="picture" data-sentry-source-file="banner-tile-item.tsx">
                <source media='(min-width: 1024px)' srcSet={desktopImageUrl || ''} />
                <LazyImage src={mobileImageUrl} alt={title} className={classNames(isBannerTileWithText ? 'h-[108px] w-[108px] lg:h-[160px] lg:w-[160px]' : 'h-full w-full')} loaderClassName='aspect-square' isLazy={isLazy} data-sentry-element="LazyImage" data-sentry-source-file="banner-tile-item.tsx" />
            </picture>

            {isBannerTileWithText && <div className='mt-1.5 w-full'>
                    <span className='text-medium block truncate text-right text-body-14 text-caption-12 font-medium lg:text-body-14'>
                        {title}
                    </span>
                    {subTitle && <p className='font-regular mt-1 truncate text-caption-12 text-text-darkGray lg:mt-2 lg:text-body-14'>
                            {subTitle}
                        </p>}
                </div>}
        </AppNextLink>;
}
export default BannerTileItem;